'use strict';

import {SectionCtrl} from "./sectionctrl.js";
import {wpModel} from "../../models/wpmodel.js";
import {participantModel} from "../../models/participantmodel.js";

export class SectionA6BudgetCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'a6_budget_before',
			on: false,
			value: null
		},
		after: {
			key: 'a6_budget_after',
			on: false,
			value: null
		}
	};

	workpackages = [];
	participants = [];

	sectionFieldsKeys = {
		a6_budget_revenues_information: true,
	};
	sectionFields = [];

	budget = {};
	budgetData = {};
	workpackagesMap = {};
	participantsMap = {};


	constructor($scope, $filter, jsDataService){
		super($scope, $filter, jsDataService);

		if(typeof(this.section.wp) !== 'undefined'){
			this.initWP(this.section.wp);
		}
		if(typeof(this.section.participants) !== 'undefined'){
			this.initParticipants(this.section.participants);
		}
		this.collectSectionFields();
		if(typeof(this.section.budget) !== 'undefined'){
			this.initBudgetData();
			this.initBudget();
		}
	}

	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
		this.calcBudget();
	}

	initWP(workpackages){
		for(let wp of workpackages){
			this.workpackagesMap['wp'+wp.id] = new wpModel(wp, this.$filter, this.jsDataService);
			this.workpackages.push(this.workpackagesMap['wp'+wp.id]);

		}
	}

	initParticipants(participants){
		this.participants = [];
		for(let participant of participants){
			this.participantsMap['p'+participant.id] = new participantModel(participant, this.$filter, this.jsDataService);
			this.participants.push(this.participantsMap['p'+participant.id]);
		}
	}

	collectSectionFields(){
		if(typeof(this.section.fields) !== 'undefined'){
			for(let ff of this.section.fields){
				if(typeof(this.sectionFieldsKeys[ff.name]) !== 'undefined' && this.sectionFieldsKeys[ff.name] && this.isField(ff.name)){
					this.sectionFields.push(ff);
				}
			}
		}
	}

	initBudget(){
		this.budget = this.section.budget;
		let totalRow = {
			total: {
				value: 0
			}
		};
		for(let r in this.budget){
			let total = {
				value: 0
			};
			for(let c in this.budget[r]){
				if(typeof(this.budget[r][c]) !== 'undefined' && typeof(this.budget[r][c].value) !== 'undefined' && !isNaN(this.budget[r][c].value)){
//					total.value += parseInt(this.budget[r][c].value);
					total.value += parseFloat(this.budget[r][c].value);
					if(typeof(totalRow[c]) === 'undefined'){
						totalRow[c] = {
							value: 0
						};
					}
//					totalRow[c].value += parseInt(this.budget[r][c].value);
					totalRow[c].value += parseFloat(this.budget[r][c].value);
				}
			}
			this.budget[r]['total'] = total;
			totalRow['total'].value += total.value;
		}
		this.budget['total'] = totalRow;
	}

	initBudgetData(){
		this.budgetData = {
			head: {
				columns: {}
			},
			body: {
				rows: {}
			},
			foot: {
				columns: {},
				span: 0
			}
		};
		if(typeof(this.section.usefundingforms) !== 'undefined' && this.section.usefundingforms){
			this.budgetData.funding = {
				columns: {}
			};
		}
		if(typeof(this.section.usecompletion) !== 'undefined' && this.section.usecompletion){
			this.budgetData.completion = {
				columns: {}
			};
		}
		if(this.isField('a6_budget_participant_acronym')){
			this.budgetData.head.columns.a6_budget_participant_acronym = this.fieldCfg.a6_budget_participant_acronym.title;
			if(typeof(this.budgetData.funding) !== 'undefined'){
				this.budgetData.funding.a6_budget_participant_acronym = {title: this.$filter('tr')('forms_of_funding')};
			}
			if(typeof(this.budgetData.completion) !== 'undefined'){
				this.budgetData.completion.a6_budget_participant_acronym = {title: this.$filter('tr')('completion_status')};
			}
		}
		if(this.isField('a6_budget_role')){
			this.budgetData.head.columns.a6_budget_role = this.fieldCfg.a6_budget_role.title;
		}
		let row = 0;
		for(let r in this.section.budget){
			this.budgetData.body.rows[r] = {};

			let col = 0;
			for(let c in this.section.budget[r]){
				if(this.participantsMap['p'+this.section.budget[r][c].participant_id].a3_participants_role == 3 ){
					break;
				}
				if(col < 1){
					if(this.isField('a6_budget_participant_acronym')){
						if(row < 1){
							this.budgetData.foot.span++;
						}
						this.budgetData.body.rows[r].a6_budget_participant_acronym = this.participantsMap['p'+this.section.budget[r][c].participant_id].getValue('a3_participants_acronym');
					}
					if(this.isField('a6_budget_role')){
						if(row < 1){
							this.budgetData.foot.span++;
						}
						this.budgetData.body.rows[r].a6_budget_role = this.participantsMap['p'+this.section.budget[r][c].participant_id].getValue('a3_participants_role');
					}
				}
				if(row < 1){
					this.budgetData.head.columns[c] = this.workpackagesMap['wp'+this.section.budget[r][c].application_wp_id].getValue('a4_1_work_activities_no');
					if(typeof(this.budgetData.funding) !== 'undefined'){
						this.budgetData.funding.columns[c] = {
							value: this.workpackagesMap['wp'+this.section.budget[r][c].application_wp_id].funding_form,
							title: this.workpackagesMap['wp'+this.section.budget[r][c].application_wp_id].getValue('funding_form'),
							wpid: this.section.budget[r][c].application_wp_id
						};
					}
					if(typeof(this.budgetData.completion) !== 'undefined'){
						this.budgetData.completion.columns[c] = {
							value: this.workpackagesMap['wp'+this.section.budget[r][c].application_wp_id].completion_status,
							title: this.workpackagesMap['wp'+this.section.budget[r][c].application_wp_id].getValue('completion_status'),
							wpid: this.section.budget[r][c].application_wp_id
						};
					}
					this.budgetData.foot.columns[c] = {
						value: 0
					};
				}
				if(typeof(this.budgetData.body.rows[r].columns) === 'undefined'){
					this.budgetData.body.rows[r].columns = {};
				}
				this.budgetData.body.rows[r].columns[c] = {
					id: this.section.budget[r][c].id,
//					value: parseInt(this.section.budget[r][c].value)
					value: parseFloat(this.section.budget[r][c].value)
				};

				col++;
			}
			if(this.isField('a6_budget_max_amount')){
				this.budgetData.body.rows[r].a6_budget_max_amount = {
					value: 0
				};
			}
			row++;
		}
		if(this.isField('a6_budget_max_amount')){
			this.budgetData.head.columns.a6_budget_max_amount = this.fieldCfg.a6_budget_max_amount.title;
			this.budgetData.foot.columns.a6_budget_max_amount = {
				value: 0
			};
			if(typeof(this.budgetData.funding) !== 'undefined'){
				this.budgetData.funding.a6_budget_max_amount = {
					value: null,
					title: ''
				};
			}
			if(typeof(this.budgetData.completion) !== 'undefined'){
				this.budgetData.completion.a6_budget_max_amount = {
					value: null,
					title: ''
				};
			}
		}
	}

	calcBudget(){
		let totalColumns = {};
		let grandTotal = 0;
		if(typeof(this.budgetData.body) !== 'undefined'){
			for(let r in this.budgetData.body.rows){
				let totalRow = 0;
				for(let c in this.budgetData.body.rows[r].columns){
					totalRow += this.budgetData.body.rows[r].columns[c].value;
					if(typeof(totalColumns[c]) === 'undefined'){
						totalColumns[c] = 0;
					}
					totalColumns[c] += this.budgetData.body.rows[r].columns[c].value;
				}
				if(this.isField('a6_budget_max_amount')){
					this.budgetData.body.rows[r].a6_budget_max_amount.value = totalRow;
					grandTotal += totalRow;
				}
			}
		}
		if(typeof(this.budgetData.foot) !== 'undefined'){
			for(let cc in totalColumns){
				this.budgetData.foot.columns[cc].value = totalColumns[cc];
			}
			if(this.isField('a6_budget_max_amount')){
				this.budgetData.foot.columns.a6_budget_max_amount.value = grandTotal;
			}
		}
	}

	getTotalWp(wpId){
		return this.getMatrix('total', 'c'+wpId);
	}

	getTotal(){
		return this.getMatrix('total', 'total');
	}

	getParticipantWp(participantId, wpId){
		return this.getMatrix('r'+participantId, 'c'+wpId);
	}

	getTotalParticipant(participantId){
		return this.getMatrix('r'+participantId, 'total');
	}

	getMatrix(row, col){
		if(typeof(this.budget[row]) === 'undefined'){
			return '';
		}
		if(typeof(this.budget[row][col]) === 'undefined'){
			return '';
		}
		return this.budget[row][col].value;
	}

	autosavePostFields(){
		let post = {
			budget: []
		};
		if(this.isField('a6_budget_revenues_information')){
			post.fields = [];
			post.fields.push(this.section.nameMap.a6_budget_revenues_information.getData());
		}
		for(let r in this.budgetData.body.rows){
			for(let c in this.budgetData.body.rows[r].columns){
				post.budget.push(this.budgetData.body.rows[r].columns[c]);
			}
		}
		if(typeof(this.section.usefundingforms) !== 'undefined' && this.section.usefundingforms){
			post.funding = [];
			for(let c in this.budgetData.funding.columns){
				post.funding.push(this.budgetData.funding.columns[c]);
			}
		}
		return post;
	}

	fieldFormat(model){
		if(typeof(model.value) === 'undefined'){
			model.value = null;
		}
		if(model.value){
			const strVal = new String(model.value);
			model.value = parseInt(strVal.replace(/[^0-9]/, '').replace(/^0/g, '').valueOf());
		}
	}

	getHeaderTooltip(hcolid) {
		const wpKey = 'wp' + hcolid.replace('c', '');
		const wp = this.workpackagesMap[wpKey];
		return wp ? wp.getValue('a4_1_work_activities_name') : '';
	}
}

